import { getSharingLink, lazyLinkBootStrap, SharingLinkInfo } from 'owa-link-data';
import { trace } from 'owa-trace';

export async function getSharingLinkInfo(
    anchorElement: HTMLAnchorElement
): Promise<SharingLinkInfo> {
    // We use the lazy version of GetSharingLink to make sure the package loads
    await lazyLinkBootStrap.import(); // This is to load the owa-link-data package
    let sharingLink: SharingLinkInfo = getSharingLink(anchorElement.id);
    if (sharingLink && anchorElement.href !== sharingLink.url) {
        sharingLink = null;
        trace.error('Stored url is different from the href on anchor element');
    }

    return sharingLink;
}
